<app-borrower-status-picker
  *ngIf="(borrower$ | async) as borrower"
  [options]="options$ | async"
  [status]="borrower.status"
  [disabled]="disabled$ | async"
  [disabledReason]="disabledReason$ | async"
  [tooltip]="borrower.stage === 'inactive' ? 'Reason: ' + borrower.last_inactive_status?.reason : ''"
  (statusChange)="handleChangeStatus($event)"
></app-borrower-status-picker>
